var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "academy-common-lib": "static-1.12338"
    },
    "depPathPrefixes": {
      "academy-common-lib": "/academy-common-lib/static-1.12338"
    },
    "project": "academy-common-lib",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};